import { bool, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { ValueCell, useEstimateEditorSettings, useEstimateTableSettings } from "@tools";
import { MaterialTitleCellEditor } from "./MaterialTitleCellEditor";
import { useMemo } from "react";

export const TaskUnitsCell = observer(({
  element,
  displayCellContent,
}) => {
  const { t } = useTranslation();
  const { allowEdition } = useEstimateEditorSettings();
  const {
    materialsSection,
    sectionUnitsName,
    setSectionUnitsName,
    visibleWorkTypes,
    workTypeColumnsMaxState,
  } = useEstimateTableSettings();
  
  const { units, unitsName, parentHoldsMaterialPrice } = element;
  
  const size = useMemo(() => (
    visibleWorkTypes.length >= 1 && !materialsSection
      ? workTypeColumnsMaxState[visibleWorkTypes.slice(-1)[0].id] ? "medium" : "small"
      : "small"
  ), [ visibleWorkTypes, workTypeColumnsMaxState, materialsSection ]);
  
  const extendPadding = useMemo(() => (
    allowEdition && !materialsSection && visibleWorkTypes.length >= 1
  ), [ allowEdition, visibleWorkTypes, materialsSection ]);
  
  return <ValueCell
    size={size}
    value={units}
    emptyInputs={parentHoldsMaterialPrice}
    onValueChange={element.setUnits}
    navigationKey="material-2"
    editable={allowEdition}
    extendPadding={extendPadding}
    displayContent={displayCellContent}
    visible
    showDecimals
    cellContentDirection="column-reverse"
  >
    {
      !materialsSection && displayCellContent &&
      <MaterialTitleCellEditor
        title={sectionUnitsName || unitsName}
        placeholder={t("views.editor.units")}
        onChange={setSectionUnitsName}
      />
    }
  </ValueCell>
});

TaskUnitsCell.propTypes = {
  element: object.isRequired,
  // actualDepthLevel: number.isRequired,
  displayCellContent: bool,
};
